/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyEmailJanus} from '../api'

export const useMutationVerifyEmailJanus = createReactQueryMutationHook('verifyEmailJanus', verifyEmailJanus)
